import React, { FunctionComponent } from 'react'
import { NavLink } from 'react-router-dom'

type TCustomLinkProps = {
	children: React.ReactNode | Element | string
	to?: string
	onClick?: () => void
	target?: string
	activeClassName?: string
	className?: string
}

const CustomLink: FunctionComponent<TCustomLinkProps> = (props) => {
	const externalUrl = !props.to || props.to?.includes('https://') || props.to?.includes('http://')
	return props.target || externalUrl ? (
		<a href={props.to} target={props.target} onClick={props.onClick} className={props.className}>
			{props.children}
		</a>
	) : (
		<NavLink activeClassName={props.activeClassName} to={props.to} onClick={props.onClick} className={props.className}>
			{props.children}
		</NavLink>
	)
}

export default CustomLink
